import React from 'react';
import styles from 'styles/components/question-builders/ExistingSurveysList.module.css';
import _ from 'lodash';
import { ActionButton } from '@ax2/common/components/ActionButton';
import UUID from '@ax2/common/model/UUID';
import SurveySchema from '@ax2/common/model/schemas/SurveySchema';
import { ExpandableQuestionsFlow } from 'components/expandable/ExpandableQuestionsFlow';
import { SurveyPurposeElement } from '../SurveyPurposeElement';
import { getSurveys } from 'rest/makeSurveyClient';
import PanelType from '@ax2/common/model/PanelType';
import { useErrorUpdateContext } from '@ax2/common/contexts/ErrorContext';
import { getErrorMessage } from '@ax2/common/helpers/error';
import { RestError } from '@ax2/common/rest/baseClient';

export interface ExistingSurveysListData {
  panel: PanelType;
  specialty?: number;
  onSelect: (surveyId: UUID) => void;
}
export const ExistingSurveysList: React.FC<ExistingSurveysListData> = props => {
  const [surveys, setSurveys] = React.useState<SurveySchema[]>();
  const updateError = useErrorUpdateContext();
  React.useEffect(() => {
    async function fetchData() {
      try {
        const data = await getSurveys();
        setSurveys(
          _.filter(data, d => {
            return props.specialty
              ? d.specialty === props.specialty && d.panel === props.panel
              : d.panel === props.panel;
          })
        );
      } catch (e) {
        updateError({
          text: getErrorMessage(e as RestError),
        });
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.panel]);
  return (
    <div>
      <div className={styles.listHeader}>
        <span>Choose A Survey From Existing</span>
      </div>
      {surveys && surveys.length > 0 ? (
        surveys.map((survey, index) => (
          <div className={styles.surveyWrapper} key={index}>
            <ExpandableQuestionsFlow
              id={'esl-survey-' + (index + 1)}
              title={`Survey ${index + 1}`}
              subtitle="Editable"
              expandLabel="Preview this survey"
              previewContent={
                <SurveyPurposeElement
                  title="Survey name"
                  text={survey.title ? survey.title : 'Not specified'}
                />
              }
              actionElement={
                <ActionButton
                  text="Use this survey"
                  type="primary"
                  onClick={() => {
                    props.onSelect(survey.id);
                  }}
                />
              }
              screeners={survey.screeners}
              questions={survey.questions}
            />
          </div>
        ))
      ) : (
        <div className={styles.messageWrapper}>
          <div className={styles.message}>
            You have no drafts for this type of surveys yet
          </div>
        </div>
      )}
    </div>
  );
};
